function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import PropTypes from 'prop-types';
import { useToggle } from '../../utils';
import OutsideClickHandler from 'react-outside-click-handler';
import classnames from 'classnames';
var propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  selectedValues: PropTypes.arrayOf(PropTypes.string)
};
var defaultProps = {
  className: '',
  selectedValues: []
};

// Wraps the `DropdownCheckboxGroup` component

function DropdownSelect(_ref) {
  var children = _ref.children,
    className = _ref.className,
    selectedValues = _ref.selectedValues;
  var _useToggle = useToggle(),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    expanded = _useToggle2[0],
    toggleExpanded = _useToggle2[1];
  return /*#__PURE__*/React.createElement(OutsideClickHandler, {
    onOutsideClick: function onOutsideClick() {
      return toggleExpanded(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-select"
  }, /*#__PURE__*/React.createElement("div", {
    className: "select-input",
    onClick: function onClick() {
      return toggleExpanded();
    }
  }, /*#__PURE__*/React.createElement("p", null, getLabel(selectedValues))), /*#__PURE__*/React.createElement("div", {
    className: classnames(className, 'options', {
      'is-active': expanded
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "scroll-box"
  }, children))));
}
DropdownSelect.propTypes = propTypes;
DropdownSelect.defaultProps = defaultProps;
function getLabel(values) {
  return values.length ? values.join(', ') : 'None';
}
export default DropdownSelect;